import {Component, Input} from '@angular/core';
import {Moment} from 'moment';

@Component({
    selector: 'app-datetime-label',
    template: `
        {{date | date: "dd/MM/yyyy 'à' HH'h'mm"}}
    `
})
export class DatetimeLabelComponent {

    @Input() date: Moment | Date;

}
